import { render, staticRenderFns } from "./WaChatlogReport.vue?vue&type=template&id=7f70ef8f"
import script from "./WaChatlogReport.vue?vue&type=script&lang=js"
export * from "./WaChatlogReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports